import CommandSection from "./command.marko";
import FeatureCard from "./feature-card.marko";

<define/Cards>
      <FeatureCard title="Knowledge Capture" icon="brain-circuit">
        <p>
          Everything the Agent learns from your interactions is captured and
          stored${" "}
          <strong>locally</strong>
          ${" "}in a versioned vector database.
        </p>
      </FeatureCard>

      <FeatureCard title="Real-time Monitoring" icon="package-plus">
        <p>
          Monitor agent activity, task progress, and system health in real-time.
        </p>
      </FeatureCard>
</define>

<decorate id="command5">
  <CommandSection
    command="hyper dash"
    iconName="brain-circuit"
    description="Peek into your Agent's brain.">
    <p class="command-intro">
      A dashboard for real-time monitoring and oversight of multi-agent
      workflows.
    </p>

    <grid.desktop cols=2 content=Cards.content />
    <div.mobile.card-slider content=Cards.content />
  </CommandSection>
</decorate>
